import { DSButton, DSCol, DSModal, DSRow, DSAlert } from '@vr/ds-react'

const ModalRequestLogisticsError = ({
  show = false,
  onClose = () => {}
}: {
  show?: boolean
  onClose?: () => void
}) => {
  return (
    <DSModal config={{ show, onClose }}>
      <DSModal.Header onClose={onClose}></DSModal.Header>
      <DSModal.Body
        css={{ textAlign: 'center', alignItems: 'center', gap: '$sm24' }}
      >
        <DSAlert type='error' hiddenBtnClose title=' Ocorreu um erro'>
          Não foi possível registrar a solicitação de logística. Por favor,
          tente novamente.
        </DSAlert>
      </DSModal.Body>
      <DSModal.Footer>
        <DSRow wrap='wrap' align='center'>
          <DSCol
            xs={12}
            lg={12}
            gap={4}
            style={{ display: 'flex' }}
            justify='center'
          >
            <DSButton variant='secondary' type='submit' onClick={onClose}>
              Fechar
            </DSButton>
          </DSCol>
        </DSRow>
      </DSModal.Footer>
    </DSModal>
  )
}

export default ModalRequestLogisticsError
